import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import queryString from 'query-string'
import headLogo from '../../images/headLogo.png'
import Login from './Login/index.jsx'
import Confirmation from './Confirmation/index.jsx'
import Info from './Info/index'
import CommonFetch from '../../requests/commonFetch'
import Upshot from './Upshot/index'

export default class Payment extends Component {
    constructor(props) {
        super(props)

        this.state = {
            paymentData: {},
            paymentInfo: {},
        }
    }

    componentDidMount() {
        this.getPaymentInfo()
    }

    getPaymentInfo = () => {
        let listURLParams = queryString.parse(this.props.location.search)
        let paymentId = listURLParams.id

        CommonFetch({
            path: `ui/depository/get_payment?id=${paymentId}`,
            method: 'GET',
        }).then(res => {
            let paymentData = res.data
            let paymentInfo = res
            delete paymentInfo['data']

            this.setState({
                paymentData,
                paymentInfo,
            })
        })
    }

    render() {
        return (
            <div className="payment-wrap">
                <div className="logo">
                    <a href="https://cryptaur.com" target="_blank">
                        <img src={headLogo} />
                    </a>
                </div>
                <div className="payment">
                    {this.paymentLeftBlock()}
                    {this.paymentRightBlock()}
                </div>
            </div>
        )
    }

    paymentLeftBlock = () => {
        let { paymentData, paymentInfo } = this.state

        if (
            !Object.keys(paymentData).length ||
            !paymentInfo.success ||
            paymentInfo.problems.length
        )
            return null

        return <Info paymentData={paymentData} />
    }

    paymentRightBlock = () => {
        let { paymentData, paymentInfo } = this.state
        let { error, problems, depositorypayment_error } = paymentInfo
        if (!Object.keys(paymentData).length) return null

        if (error || problems.length || depositorypayment_error) {
            return (
                <Upshot
                    status="warning"
                    paymentData={paymentData}
                    paymentInfo={paymentInfo}
                    additionalData={{
                        desc: error
                            ? error
                            : problems.length
                            ? problems
                            : depositorypayment_error
                            ? depositorypayment_error
                            : '',
                    }}
                />
            )
        } else {
            return this.paymentComponentSelection()
        }
    }

    paymentComponentSelection = () => {
        let { paymentData, paymentInfo } = this.state

        switch (paymentInfo.state) {
            case 'not_authed':
                return (
                    <Login
                        captchaKey={this.props.captchaKey}
                        switchSignIn={this.props.switchSignIn}
                        getPaymentInfo={this.getPaymentInfo}
                    />
                )
                break
            case 'not_set_2fa':
                return (
                    <Upshot
                        status="warning"
                        paymentData={paymentData}
                        paymentInfo={paymentInfo}
                        additionalData={{
                            desc: 'not_set_2fa',
                        }}
                    />
                )
                break
            case 'wait_agree':
                return (
                    <Confirmation
                        captchaKey={this.props.captchaKey}
                        paymentData={paymentData}
                        paymentState={paymentInfo.state}
                        paymentTFA={paymentInfo.type_2fa}
                        getPaymentInfo={this.getPaymentInfo}
                    />
                )
                break
            case 'wait_2fa_code':
                return (
                    <Confirmation
                        captchaKey={this.props.captchaKey}
                        paymentData={paymentData}
                        paymentState={paymentInfo.state}
                        paymentTFA={paymentInfo.type_2fa}
                        getPaymentInfo={this.getPaymentInfo}
                    />
                )
                break
            case 'complete':
                return (
                    <Upshot
                        status="complete"
                        paymentData={paymentData}
                        paymentInfo={paymentInfo}
                    />
                )
                break
            default:
                return (
                    <div>
                        <h1>404</h1>
                    </div>
                )
        }
    }
}
